import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HelperFunctions } from 'src/app/util/util-functions';

@Component({
  selector: 'app-scroll-paginator',
  templateUrl: './scroll-paginator.component.html',
  styleUrls: ['./scroll-paginator.component.scss']
})
export class ScrollPaginatorComponent {

  @Input() itemsQuantity: number = 0;
  @Input() totalElements: number = 0;
  @Input() isLoading: boolean = false;
  @Input() page: number = 0;
  @Input() totalPages: number = 1;
  @Input() selector: string = '#main';
  @Input() fromRoot: boolean = true;
  @Input() isStatic: boolean = false;


  @Output() loadPageEvent = new EventEmitter();

  /**
  * A function that checks if it is a mobile device
  * @returns {boolean}
  */
  isMobile(): boolean {
    return HelperFunctions.isMobile();
  }

  /**
  * A function that emmits the load event
  * @returns {boolean}
  */
  onLoadPage(): void {
    this.loadPageEvent.emit();
  }
}
